import { BigNumber } from 'ethers';

const extraPercentage = parseInt(process.env.REACT_APP_EXTRA_GAS_LIMIT_PERCENTAGE || '', 10) || 20;

export function calcGasLimit(estimatedGas: BigNumber): BigNumber {
  return estimatedGas.mul(100 + extraPercentage).div(100);
}
